
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"30","height":"31","viewBox":"0 0 30 31","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"y":".3","width":"30","height":"30","rx":"15","fill":"#122546"}}),_c('g',{attrs:{"clip-path":"url(#ongoing_svg__clip0_2680_196)"}},[_c('path',{attrs:{"d":"M10.667 9.973v10.055c0 .766.86 1.23 1.516.82l8.027-5.028a.962.962 0 000-1.638l-8.027-5.028c-.657-.412-1.516.053-1.516.819z","fill":"#fff"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"ongoing_svg__clip0_2680_196"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(9.343 8.228)","d":"M0 0h11.314v14.143H0z"}})])])])
          )
        }
      }
    